<!--
무자료 등록(재고방식) > 상품리스트 > 상품1개
------------------------------------
-->
<template>

    <div class="uk-flex uk-flex-left uk-flex-top uk-margin-large-bottom">
        <div class="uk-width-auto">
            <div class="uk-margin-right">
                <img
                    :src="prod.img_url"
                    :data-src="prod.img_url"
                    class="lazyloaded"
                    style="object-fit: contain; width: 150px; height: 150px;"
                />

                <div class="uk-text-center">
                    <a
                        class="uk-button uk-button-black uk-button-small"
                        title="상세페이지 (새창열기)"
                        :href="'/prods/'+prod.id"
                        target="_blank"
                    >
                        <i class="material-icons">link</i>
                        상품상세
                    </a>
                </div>

            </div>
        </div>

        <div class="uk-width-expand">
            <!-- 상품정보 테이블 -->
            <table class="prod-table">
                <tr>
                    <th class="highlight">
                        <i class="material-icons">
                            info
                        </i>
                        수량(QTY)
                    </th>
                    <td>
                        {{ prod.amount }}
                    </td>

                    <th class="highlight">
                        <i class="material-icons">
                            info
                        </i>
                        사이즈
                    </th>
                    <td>
                        {{ prod.size }}
                    </td>

                    <th>
                        <i class="material-icons">
                            info
                        </i>
                        색상
                    </th>
                    <td colspan="3">
                        {{ prod.color }}
                    </td>
                </tr>

                <tr>
                    <th>
                        <i class="material-icons">
                            info
                        </i>
                        상품명
                    </th>
                    <td colspan="3">
                        {{ prod.name }}
                    </td>
                    <th>
                        <i class="material-icons">
                            receipt
                        </i>
                        해외주문번호
                    </th>
                    <td>
                        {{ prod.buy_order_code }}
                    </td>
                </tr>
                <tr>
                    <th>
                        <i class="material-icons">
                            comment
                        </i>
                        관리메모
                    </th>
                    <td colspan="3">
                        {{ prod.memo }}
                    </td>
                    <th>
                        <i class="material-icons">
                            comment
                        </i>
                        유통기한
                    </th>
                    <td>
                        {{ prod.expiration_date }}
                    </td>

                </tr>
            </table>

            <div class="uk-flex uk-flex-between">
                <!-- 수정 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-button-small"
                    @click="$refs.update.form(prod)"
                >
                    <i class="material-icons">edit</i>
                    수정
                </button>

                <!-- 상품수정 컴포넌트 -->
                <update-prod
                    ref="update"
                    :csrf-token="csrfToken"
                    :region-id="regionId"
                    :session-owner="sessionOwner"
                    @updated="prod => $emit('updated', prod)"
                >
                </update-prod>

                <!-- 삭제 -->
                <button
                    type="button"
                    class="uk-button uk-button-danger uk-button-small"
                    @click="$refs.remove.form(prod)"
                >
                    <i class="material-icons">delete</i>
                    삭제
                </button>

                <!-- 상품삭제 컴포넌트 -->
                <remove-prod
                    ref="remove"
                    :csrf-token="csrfToken"
                    :region-id="regionId"
                    @removed="prod => $emit('removed', prod)"
                >
                </remove-prod>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        components: {
            'remove-prod': require('./remove-prod.vue').default,
            'update-prod': require('./update-prod.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            // 지역ID
            regionId: Number,

            // 첨부파일용 로그인(세션)ID
            sessionOwner: Number,

            /**
             * 상품정보
             */
            prod: {
                type: Object,
            }
        },
        data: function () {
            return {

            };
        },
        computed: {

        },
        methods: {

        },


    }
</script>

<style lang="scss" scoped>
    // 테이블
    .prod-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        th, td {
            padding: 10px;
            //min-width: 10rem;
            border: 1px solid #cfcfcf;

            text-align: left;
            font-weight: normal;
            color: #000;
        }

        th {
            font-size: 1rem;
            background-color: #fefefe;
            width: 10rem;

            .material-icons {
                vertical-align: middle;
                font-size: 1.5rem;
                color: #aaa;
            }

            &.highlight .material-icons{
                color: #1e87f0 !important;
            }

        }
        td {
            text-align: left;
            font-size: 1rem;
            color: #000;
        }

    }
</style>